document.addEventListener('DOMContentLoaded', async function () {
  // Run only on the cart page
  if (!window.location.pathname.startsWith('/cart')) return;

  try {
    // Fetch current cart data
    const cartResponse = await fetch('/cart.js');
    if (!cartResponse.ok) throw new Error('Failed to fetch cart data');
    const cart = await cartResponse.json();

    // Helper function to fetch product tags by handle
    async function getProductTags(handle) {
      try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) throw new Error(`Failed to fetch product: ${handle}`);
        const product = await res.json();
        return product.tags.map(tag => tag.toLowerCase());
      } catch {
        return [];
      }
    }

    // Fetch tags for all products in cart
    const allTagsArrays = await Promise.all(
      cart.items.map(item => getProductTags(item.handle))
    );

    // Flatten array and lowercase tags for uniformity
    const allTags = allTagsArrays.flat();

    // Check cart for conflicting tags
    const hasPickup = allTags.includes('pickup-only');
    const hasDelivery = allTags.includes('delivery-only');

    if (hasPickup && hasDelivery) {
      alert('आप एक साथ "Pickup" और "Delivery" दोनों प्रकार के प्रोडक्ट्स checkout नहीं कर सकते। कृपया एक प्रकार चुनें।');
      
      // Disable the checkout button in Dawn theme cart page
      const checkoutButton = document.querySelector('form[action="/cart"] button[name="checkout"]');
      if (checkoutButton) {
        checkoutButton.disabled = true;
        checkoutButton.style.backgroundColor = '#ccc';
        checkoutButton.style.cursor = 'not-allowed';
        checkoutButton.title = 'Checkout disabled because cart contains both pickup and delivery products.';
      }
    }

  } catch (error) {
    console.error('Error during cart validation:', error);
  }
});
